import { useCallback } from "react";

import { chatToolCallsVar } from "@apps/ask-ai/ask-ai-context";
import usePusher from "@components/use-pusher/use-pusher";

export default function PusherChatToolCall({
  channelName,
}: {
  channelName: string;
}) {
  const handleChatToolCall = useCallback(
    ({
      chat_session_id,
      tool_name,
      result_count,
      arguments: args,
      output,
    }: {
      chat_session_id: number;
      tool_name: string;
      result_count?: number;
      arguments?: string;
      output?: string;
    }) => {
      chatToolCallsVar([
        ...chatToolCallsVar(),
        {
          chatSessionId: chat_session_id,
          toolName: tool_name,
          resultCount: result_count,
          arguments: args,
          output,
        },
      ]);
    },
    [],
  );
  usePusher(channelName, "chat_tool_call", handleChatToolCall);
  return null;
}
